import { Typography } from '@material-ui/core';
import { CurrentMonth } from '../../components/Calendar/CurrentMonth/CurrentMonth.component';
import Layout from '../../components/Layout/Layout.component';
import Breadcrumbs from '../../components/Breadcrumbs.component';
import { Paths } from '../../utils/routerUrls';
import { t } from 'i18next';
import { useStyles } from '../styles';
import { useLayoutContext } from '../../Context/Layout.context';
import { AssessmentSessionDate, AssessmentSessionDateResponse } from './Calendar.types';
import { getAssessmentSessionCalendar } from '../../services/exams/assessmentSession/assessments.service';
import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { CalendarNav } from '../../components/Calendar/CalendarNav/CalendarNav.component';
import { SessionList } from '../../components/Calendar/SessionList/SessionList.component';
import { SelectChangeEvent } from '@mui/material';
import useSessionUser from '../../hooks/useSessionUser';
import { useTranslation } from 'react-i18next';

export const Calendar: React.FC = () => {
  const classes = useStyles();
  const { showLoader, openAlert, isSidebarMinimized: isSidebarMinimazed } = useLayoutContext();

  const [assementSessionDateRecord, setAssementSessionDateRecord] = useState<AssessmentSessionDateResponse[]>([]);
  const [selectedAssementSessionDate, setselectedAssementSessionDate] = useState<AssessmentSessionDateResponse>();
  const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const { user } = useSessionUser();
  const { t } = useTranslation();

  const isAdmin = user.profile.account_type === 'administrator'

  const handleGetAssessmentSessionCalendar = () => {
    showLoader(true);
    getAssessmentSessionCalendar()
      .then(
        (result: AxiosResponse<AssessmentSessionDateResponse[]>) => {
          if (result.data.length) {
            setAssementSessionDateRecord(result.data);
            setselectedAssementSessionDate(result.data[0]);
          }
        },
        () => {
          openAlert('get_error');
        },
      )
      .finally(() => {
        showLoader(false);
      });
  };

  useEffect(() => {
    handleGetAssessmentSessionCalendar();
  }, []);

  const getTransformedData = (data: AssessmentSessionDateResponse): AssessmentSessionDate => {
    return {
      examTaskGroupNameAndSheetCode: data.examTaskGroupNameAndSheetCode,
      assessmentSessionStart: new Date(data.assessmentSessionStart),
      assessmentSessionEnd: new Date(data.assessmentSessionEnd),
      scoringStart: new Date(data.scoringStart),
      trainingStart: data.trainingStart ? new Date(data.trainingStart) : null,
      qualificationStart: data.qualificationStart ? new Date(data.qualificationStart) : null,
      assementSessionId: data.assessmentSessionId,
      isDomesticCoordinator: data.isDomesticCoordinator
    };
  };

  const handleDateChange = (direction: 'left' | 'right') => {
    switch (direction) {
      case 'left':
        {
          if (selectedMonth === 1) {
            setSelectedMonth(12);
            setSelectedYear(selectedYear - 1);
          } else {
            setSelectedMonth(selectedMonth - 1);
          }
        }
        break;
      case 'right': {
        if (selectedMonth === 12) {
          setSelectedMonth(1);
          setSelectedYear(selectedYear + 1);
        } else {
          setSelectedMonth(selectedMonth + 1);
        }
      }
    }
  };

  const handleSetCurrentDate = () => {
    setSelectedMonth(new Date().getMonth() + 1);
    setSelectedYear(new Date().getFullYear());
  };

  const handleChangeSession = (event: SelectChangeEvent<string>) => {
    const session = assementSessionDateRecord.find((e) => e.examTaskGroupNameAndSheetCode === event.target.value);
    setselectedAssementSessionDate(session);
  };

  return (
    <>
      <Layout viewType={isAdmin ? 'admin' : 'fullwidthForExaminer'}>
        <div className={classes.tableAndBreadcrumContainer}>
          <div className={classes.adminBreadcrumbHeader}>
            <Breadcrumbs listRoute={Paths.calendar} currentList={'Kalendarz zdarzeń'} />
          </div>
          <div className={classes.tableWhiteCardFlex}>
            <div className={classes.filtersContainerFlex} style={{ marginBottom: '55px' }}>
              <div className={classes.usersHeaderContainer}>
                <Typography variant='h1' className={classes.gridHeader}>Kalendarz zdarzeń</Typography>
                <CalendarNav
                  year={selectedYear}
                  monthIndex={selectedMonth}
                  onChange={handleDateChange}
                  setCurrentDate={handleSetCurrentDate}
                />
              </div>
              {assementSessionDateRecord.length && (
                <SessionList
                  sessions={assementSessionDateRecord}
                  selectedSession={
                    selectedAssementSessionDate ? selectedAssementSessionDate : assementSessionDateRecord[0]
                  }
                  onChange={handleChangeSession}
                />
              )}
            </div>
            <div
              className={[
                classes.adminTableContainerFlex,
                isAdmin && isSidebarMinimazed ? classes.adminTableContainerFullWidth : isAdmin ? classes.adminTableContainerNarrowed : '',
                !isAdmin ? classes.examinerCalendarContainer : '',
              ].join(' ')}
              style={{ height: 'calc(100vh - 290px)' }}
            >
              {selectedAssementSessionDate && (
                <CurrentMonth
                  month={selectedMonth}
                  year={selectedYear}
                  data={getTransformedData(selectedAssementSessionDate)}
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};
